module.exports = __webpack_public_path__ + "static/media/4.4.c20ad450.zip";